import { render } from "./CategoryInformationComponent.vue?vue&type=template&id=995fc080&scoped=true"
import script from "./CategoryInformationComponent.vue?vue&type=script&lang=js"
export * from "./CategoryInformationComponent.vue?vue&type=script&lang=js"

import "./CategoryInformationComponent.vue?vue&type=style&index=0&id=995fc080&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-995fc080"]])

export default __exports__